import React from "react";

import { StyledLabelWrapper } from "./label.style";

const Label = ({ children, required }) => (
  <StyledLabelWrapper>
    <div dangerouslySetInnerHTML={{ __html: children }}></div>
    {!required && <span>(optional)</span>}
  </StyledLabelWrapper>
);

export default Label;
